/**
 * Application-wide constants
 * NOTE: This file is imported on both server and client - keep it server-safe!
 */

// Application version - update manually as needed
export const APP_VERSION = '1.4.67';

// Default currency
export const DEFAULT_CURRENCY = 'USD';

// Subscription Tier Constants
export const TIERS = {
  FREE: 'free',
  PRO: 'pro',
  PROPLUS: 'proplus',
  ADMIN: 'admin'
};

// Tiers that can be cancelled (paid subscriptions)
export const CANCELLABLE_TIERS = [TIERS.PRO, TIERS.PROPLUS];

// Complete language information - single source of truth
export const LANGUAGES = [
  { 
    code: 'en', 
    name: 'English', 
    nativeName: 'English', 
    flag: 'EN',
    dateFnsLocale: 'enUS',
    ogLocale: 'en_US',
    isRtl: false
  },
  { 
    code: 'fr', 
    name: 'French', 
    nativeName: 'Français', 
    flag: '🇫🇷',
    dateFnsLocale: 'fr',
    ogLocale: 'fr_FR',
    isRtl: false
  },
  { 
    code: 'es', 
    name: 'Spanish', 
    nativeName: 'Español', 
    flag: '🇪🇸',
    dateFnsLocale: 'es',
    ogLocale: 'es_ES',
    isRtl: false
  },
  { 
    code: 'ar', 
    name: 'Arabic', 
    nativeName: 'العربية', 
    flag: '🇸🇦',
    dateFnsLocale: 'ar',
    ogLocale: 'ar_SA',
    isRtl: true
  },
  { 
    code: 'he', 
    name: 'Hebrew', 
    nativeName: 'עברית', 
    flag: '🇮🇱',
    dateFnsLocale: 'he',
    ogLocale: 'he_IL',
    isRtl: true
  }
];

// Language code to language name mapping (for backward compatibility)
// Used for AI prompts and templates
export const LANGUAGE_MAP = LANGUAGES.reduce((acc, lang) => {
  acc[lang.code] = lang.name;
  return acc;
}, {});

// Language code to date-fns locale key mapping (for backward compatibility)
// Used for date formatting with locale support
export const DATE_FNS_LOCALE_MAP = LANGUAGES.reduce((acc, lang) => {
  acc[lang.code] = lang.dateFnsLocale;
  return acc;
}, {});

// Application constants
export const CONSTANTS = {
  LIMITS: {
    PLANS_LIMIT: 3,
    MAX_DAYS_PER_PLAN: 10,
    AI_CALLS_PER_DAY_PRO: 50,
    AI_CALLS_PER_DAY_PROPLUS: 200,
    GROUPS_LIMIT_PRO: 5,
    EMAILS_PER_GROUP_LIMIT_PRO: 10
  },
  PRICES: {
    PRO_MONTHLY: '$7',
    PRO_YEARLY: '$66',
    PRO_YEARLY_MONTHLY_EQUIVALENT: '$5.5',
    PRO_PLUS_MONTHLY: '$80',
    PRO_PLUS_YEARLY: '$800',
    PRO_PLUS_YEARLY_MONTHLY_EQUIVALENT: '$67'
  }
}; 